import { GDPRSecurityModal } from '@/components/common/GDPRSecurityModal';
import { Shield } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const DataProtectionLink = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          className="inline-flex min-h-11 items-center gap-2 rounded-md px-2 text-xs font-medium text-neutral-500 underline-offset-4 transition-colors hover:text-neutral-700 hover:underline focus:ring-2 focus:ring-neutral-300 focus:ring-offset-2 focus:outline-none"
        >
          <Shield className="h-4 w-4" aria-hidden="true" />
          {t('gdpr.badge')}
        </button>
      </div>

      <GDPRSecurityModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
